import { proxy, useSnapshot } from "valtio";

export interface IAudioTrack {
    src: string;
    title: string;
    thumbnailUrl?: string;
    category?: string;
    mediaLabel?: string;
    mediaDuration?: string;
    slug?: string;
}

export const audioPlayerStore = proxy({
    track: null as IAudioTrack | null,
    isPlaying: false,
    isEnded: false,
    isLoaded: false,
    currentTime: 0,
    duration: 0,

    /**
     * Signals that the player should be mounted.
     */
    load: () => {
        audioPlayerStore.isLoaded = true;
    },

    play: (track: IAudioTrack) => {
        audioPlayerStore.track = track;
        audioPlayerStore.isPlaying = true;
        audioPlayerStore.isEnded = false;
        audioPlayerStore.isLoaded = true;
        audioPlayerStore.currentTime = 0;
        audioPlayerStore.duration = 0;
    },

    resume: () => {
        audioPlayerStore.isEnded = false;
        audioPlayerStore.isPlaying = true;
    },

    pause: () => {
        audioPlayerStore.isPlaying = false;
    },

    end: () => {
        audioPlayerStore.isPlaying = false;
        audioPlayerStore.isEnded = true;
    },

    toggle: () => {
        if (audioPlayerStore.isEnded) {
            audioPlayerStore.isEnded = false;
            audioPlayerStore.isPlaying = true;
        } else {
            audioPlayerStore.isPlaying = !audioPlayerStore.isPlaying;
        }
    },

    setCurrentTime: (time: number) => {
        audioPlayerStore.currentTime = time;
    },

    setDuration: (duration: number) => {
        audioPlayerStore.duration = duration;
    },

    close: () => {
        audioPlayerStore.track = null;
        audioPlayerStore.isPlaying = false;
        audioPlayerStore.isEnded = false;
        audioPlayerStore.currentTime = 0;
        audioPlayerStore.duration = 0;
    },
});

export function useAudioPlayerStore() {
    return useSnapshot(audioPlayerStore);
}
